export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्राप्तकर्ता:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["उपयोगकर्ता नहीं मिला"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["संपर्क"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["विस्तृत जानकारी"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["उपयोगकर्ता चयन"])}
}